import {
  ImagePreview,
  ImagePreviewItem,
  NoImageContainer,
  RemoveImageButtonContainer,
} from "~styled/image"
import { ImageListType, ImageType } from "react-images-uploading"
import RemoveButton from "~components/imageUpload/RemoveButton"
import UploadIcon from "~images/icons/upload.svg?react"

interface Props {
  images: ImageListType[] | null
  removeImage: (v) => void
  className?: string
  text: string
  removeIcon: boolean
  imageRemoveAll: () => void
}

const PreviewImage = ({
  images,
  removeImage,
  className,
  text,
  removeIcon,
  imageRemoveAll,
}: Props) => {
  const handleRemoveImage = v => {
    removeImage(v)
  }

  if (images?.length) {
    if (Array.isArray(images)) {
      return (
        <>
          {images.map((image: ImageType, index) => (
            <ImagePreviewItem key={index} className={className}>
              {removeIcon && (
                <RemoveImageButtonContainer>
                  <RemoveButton onClick={() => handleRemoveImage(index)} />
                </RemoveImageButtonContainer>
              )}
              <ImagePreview
                key={index}
                src={image.dataURL}
                className={className}
              />
            </ImagePreviewItem>
          ))}
        </>
      )
    } else {
      return (
        <ImagePreviewItem className={className}>
          {removeIcon && (
            <RemoveImageButtonContainer>
              <RemoveButton onClick={() => imageRemoveAll()} />
            </RemoveImageButtonContainer>
          )}
          <ImagePreview src={images} className={className} />
        </ImagePreviewItem>
      )
    }
  }

  return (
    <NoImageContainer className={className}>
      <UploadIcon />
      {text}
    </NoImageContainer>
  )
}

export default PreviewImage
